export class GetAllTypeMarketAction {
  static readonly type = '[TypeMarket] Get All';
  constructor() {}
}
